import { WHITE_ADD_CIRCLE, lockClose } from '../../../../../../assets/hostedassets';
import type { AicaEntityState } from '../../../../../../store/dashboard/relatedParties/relatedPartyTransactions.types';

export const ENTITY_HOVER_SOURCE = 'related_party_hover';

export const ENTITY_HOVER_CTA_LABEL = {
    VIEW: 'View AICA Report',
    UNLOCK: 'Unlock AICA Report',
    ADD: 'Add AICA Report',
} as const;

export const FINANCIALS_NOT_AVAILABLE = 'Financials: Not Available';

export const FINANCIALS_LABEL = 'Financials';

export const FINANCIAL_PLACEHOLDER = '₹00Cr';

export const ENTITY_STATUS_ACTIVE = 'ACTIVE';

export const ENTITY_HOVER_LABELS = {
    REVENUE: 'Revenue',
    PAT: 'PAT',
    NET_WORTH: 'Net Worth',
    ROW_NET_WORTH: 'Net-Worth',
    RELATIONSHIP: 'Relationship',
    SHAREHOLDING: 'Shareholding',
    INCORPORATION_DATE: 'Incorporation Date',
    ENTITY_STATUS: 'Entity Status',
    FUNDING_RAISED: 'Funding Raised',
    INVESTORS: 'Investors',
    ACTIVE_COMPLIANCE: 'Active Compliance',
    PAID_UP_CAPITAL: 'Paid Up Capital',
    TOTAL_OBLIGATION: 'Total Obligation of Contribution',
    SUM_OF_CHARGES: 'Sum of Charges',
    CIN: 'CIN',
    LLPIN: 'LLPIN',
    NEXT_CIN: 'Next CIN',
    FINANCIAL_YEAR: 'Financial Year',
    CIRP_STATUS: 'CIRP Status',
    DESIGNATION: 'Designation',
    DATE_OF_APPOINTMENT: 'Date of Appointment',
    CURRENT_DESIGNATION_DATE: 'Appointed to current designation',
    APPOINTMENT_STATUS: 'Appointment Status',
} as const;

export const ENTITY_STATUS_PILL = { ACTIVE: 'Active', INACTIVE: 'Inactive' } as const;

export const ROW_DETAILS_LOCKED = 'Locked';

export const ROW_DETAILS_SEPARATOR = ' • ';

export const ROW_FINANCIALS_OVERFLOW_MARKER = '…';

export const SECOND_DEGREE = '2';

export const ENTITY_HOVER_CTA_START_ICON: Partial<Record<AicaEntityState, string>> = {
    UNLOCK: lockClose,
    ADD: WHITE_ADD_CIRCLE,
};
